import { Dispatch } from 'redux';
import { isArray } from 'util';

import { fetcher } from '../../lib/request';

import { Discussion } from '../../models/Accounting/Discussion';

const ACCOUNTING_HOST = process.env.REACT_APP_ACCOUNTING_HOST;
const ACCOUNTING_KEY = process.env.REACT_APP_ACCOUNTING_KEY;

export const GET_DISCUSSIONS_REQUEST = 'ACCOUNTING_GET_DISCUSSIONS_REQUEST';
export const GET_DISCUSSIONS_RESPONSE = 'ACCOUNTING_GET_DISCUSSIONS_RESPONSE';
export const GET_DISCUSSIONS_ERROR = 'ACCOUNTING_GET_DISCUSSIONS_ERROR';

export const GET_MORE_DISCUSSIONS_REQUEST = 'ACCOUNTING_GET_MORE_DISCUSSIONS_REQUEST';
export const GET_MORE_DISCUSSIONS_RESPONSE = 'ACCOUNTING_GET_MORE_DISCUSSIONS_RESPONSE';
export const GET_MORE_DISCUSSIONS_ERROR = 'ACCOUNTING_GET_MORE_DISCUSSIONS_ERROR';

export const GET_DISCUSSION_REQUEST = 'ACCOUNTING_GET_DISCUSSION_REQUEST';
export const GET_DISCUSSION_RESPONSE = 'ACCOUNTING_GET_DISCUSSION_RESPONSE';
export const GET_DISCUSSION_ERROR = 'ACCOUNTING_GET_DISCUSSION_ERROR';

export const CREATE_DISCUSSION_REQUEST = 'ACCOUNTING_CREATE_DISCUSSION_REQUEST';
export const CREATE_DISCUSSION_RESPONSE = 'ACCOUNTING_CREATE_DISCUSSION_RESPONSE';
export const CREATE_DISCUSSION_ERROR = 'ACCOUNTING_CREATE_DISCUSSION_ERROR';

export const MAKE_READ_DISCUSSION_REQUEST = 'ACCOUNTING_MAKE_READ_DISCUSSION_REQUEST';
export const MAKE_READ_DISCUSSION_RESPONSE = 'ACCOUNTING_MAKE_READ_DISCUSSION_RESPONSE';
export const MAKE_READ_DISCUSSION_ERROR = 'ACCOUNTING_MAKE_READ_DISCUSSION_ERROR';

export const GET_MESSAGES_REQUEST = 'ACCOUNTING_GET_MESSAGES_REQUEST';
export const GET_MESSAGES_RESPONSE = 'ACCOUNTING_GET_MESSAGES_RESPONSE';
export const GET_MESSAGES_ERROR = 'ACCOUNTING_GET_MESSAGES_ERROR';

export const GET_MORE_MESSAGES_REQUEST = 'ACCOUNTING_GET_MORE_MESSAGES_REQUEST';
export const GET_MORE_MESSAGES_RESPONSE = 'ACCOUNTING_GET_MORE_MESSAGES_RESPONSE';
export const GET_MORE_MESSAGES_ERROR = 'ACCOUNTING_GET_MORE_MESSAGES_ERROR';

export const SEND_MESSAGES_REQUEST = 'ACCOUNTING_SEND_MESSAGES_REQUEST';
export const SEND_MESSAGES_RESPONSE = 'ACCOUNTING_SEND_MESSAGES_RESPONSE';
export const SEND_MESSAGES_ERROR = 'ACCOUNTING_SEND_MESSAGES_ERROR';

export const SET_DISCUSSION = 'ACCOUNTING_SET_DISCUSSION';

function createFormData(data: any): FormData {
    const formData = new FormData();
    Object.keys(data).forEach(field => {
        const value = (data as any)[field];
        if (isArray(value)) {
            value.forEach(v => formData.append('attachments[]', v));
        }
        if (value !== undefined && value !== null && !isArray(value)) {
            formData.append(field, value);
        }
    });
    return formData;
}

export const getDiscussionsAction = (clientId: string, page = 1) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_DISCUSSIONS_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/discussions?client_type=concierge_client` +
            `&client_id=${clientId}&page=${page}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_DISCUSSIONS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_DISCUSSIONS_ERROR,
            error,
        });
    }
};

export const getMoreDiscussionsAction = (userId: string, page = 1) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MORE_DISCUSSIONS_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/discussions?client_type=concierge_client` +
            `&client_id=${userId}&page=${page}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_DISCUSSIONS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_MORE_DISCUSSIONS_ERROR,
            error,
        });
    }
};

export const getDiscussionAction = (discussionId: number, clientId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_DISCUSSION_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/discussions/${discussionId}` +
            `?client_type=concierge_client&client_id=${clientId}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_DISCUSSION_ERROR,
            error,
        });
    }
};

export const createDiscussionAction = (clientId: string, title: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CREATE_DISCUSSION_REQUEST,
    });

    try {
        const body = {
            client_type: 'concierge_client',
            client_id: clientId,
            title,
        };

        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/discussions`)
            .post(body)
            .contentType('application/json')
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: CREATE_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: CREATE_DISCUSSION_ERROR,
            error,
        });
    }
};

export const makeReadDiscussionAction = (discussionId: number, userId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: MAKE_READ_DISCUSSION_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/discussions/${discussionId}/read?` +
            `client_type=concierge_client&client_id=${userId}`)
            .put()
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: MAKE_READ_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: MAKE_READ_DISCUSSION_ERROR,
            error,
        });
    }
};

export const getMessagesAction = (discussionId: number, userId: string, page = 1) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MESSAGES_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/messages?client_type=concierge_client` +
            `&client_id=${userId}&discussion_id=${discussionId}&page=${page}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_MESSAGES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_MESSAGES_ERROR,
            error,
        });
    }
};

export const getMoreMessagesAction = (id: number, userId: string, page = 1) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_MORE_MESSAGES_REQUEST,
    });

    try {
        const response = await fetcher(`${ACCOUNTING_HOST}/api/v1/messages?client_type=concierge_client` +
            `&client_id=${userId}&discussion_id=${id}&page=${page}`)
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_MESSAGES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_MORE_MESSAGES_ERROR,
            error,
        });
    }
};

export const sendMessagesAction = (
    discussionId: number,
    userId: string,
    content: string,
    attachments: File[],
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEND_MESSAGES_REQUEST,
    });

    try {
        const body = {
            discussion_id: discussionId,
            client_type: 'concierge_client',
            client_id: userId,
            content,
            attachments,
        };

        const response = await fetcher(`${process.env.REACT_APP_ACCOUNTING_HOST}/api/v1/messages`)
            .post(createFormData(body))
            .auth(`Basic ${ACCOUNTING_KEY}`)
            .json();

        dispatch({
            type: SEND_MESSAGES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: SEND_MESSAGES_ERROR,
            error,
        });
    }
};

export const setDiscussionAction = (discussion: Discussion) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DISCUSSION,
        discussion,
    });
};



// WEBPACK FOOTER //
// ./src/actions/Accounting/discussion.ts